<template>
  <v-container fill-height justify-center align-center >
    <!-- <v-layout row wrap> -->
      <v-flex xs12 sm10 lg5 md8>
        <v-card class="mt-0 pt-0">
          <v-card-title class="primary">
            <h4 style="color:white">TAP-FORGOT-PASSWORD</h4>
          </v-card-title>
          <v-card-text>
            <v-form ref="forgotPasswordForm">
              <v-layout row wrap>
                <v-flex  xs12 md12>
                  <v-text-field box name="email" v-model="user.email" label="Email" :rules="rules.email" required></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
            <v-layout row>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" to="/" round outline>Login</v-btn>
              <v-btn color="primary" @click.native="forgotpassword" round>SUBMIT</v-btn>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    <!-- </v-layout> -->
  </v-container>
</template>
<script>
/* globals Store */
import { User } from '@/models'
export default {
  data () {
    return {
      alertDialogOpen: false,
      user: new User(),
      // email: ''
      rules: {
        isRequired: [
          (v) => !!v || 'Required'
        ],
        email: [
          (v) => !!v || 'Required',
          (v) => /.+@.+/.test(v) || 'E-mail must be valid'
        ]
      }
    }
  },
  methods: {
    forgotpassword () {
      if (this.$refs.forgotPasswordForm.validate()) {
        Store.dispatch('user/forgotpassword', this.user)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue